import Gradient from '../../lib/stripe-gradient/Gradient';

export function gradient(page) {
	/*--------------------------------
	グラデーション
	--------------------------------*/
	const gradient01 = new Gradient({
		canvas: '#canvas01',
		colors: ['#ff8467', '#5f51bc', '#ff8467', '#5f51bc'],
	});




	setTimeout(showCopy, 300);
	setTimeout(showDesp, 700);
	setTimeout(showDesp2, 700);

	let copy = document.querySelector(".serviceBox .overArea .ttl");
	let desp1 = document.querySelector(".serviceBox .overArea .despPc");
	let desp2 = document.querySelector(".serviceBox .overArea .despSp");

	function showCopy() {
		copy.classList.add("active");
	}
	function showDesp() {
		desp1.classList.add("active");
		desp2.classList.add("active");
	}

	function showDesp2() {
		copy.classList.add("whiteStr");
		desp1.classList.add("whiteStr");
		desp2.classList.add("whiteStr");
	}

}


